import Box from "@/common/components/Box";
import Button from "@/common/components/Button";
import GoBackButton from "@/common/components/GoBackButton";
import Skeleton from "@/common/components/Skeleton";
import { useParams } from "react-router-dom";
import CreateMaintenanceForwardingHeader from "./CreateMaintenanceForwardingHeader";

const CreateMaintenanceForwardingDirectiveLoading = () => {
  const { companyId, workflowId } = useParams();

  return (
    <div className="inner-screen">
      <CreateMaintenanceForwardingHeader
        showCancelButton
        actions={(
          <Button disabled>
            Confirmar
          </Button>
        )}
      />

      <Box className="flex-1 overflow-hidden p-4 flex flex-col gap-4">
        <div className="flex items-center gap-2">
          <GoBackButton
            fallback={`/companies/${companyId}/maintenance/workflows/${workflowId}/forwardings/create`}
            searchLastRouteFromFallback
          />

          <Skeleton className="h-7 w-40" />
        </div>

        <div className="flex flex-col gap-1">
          <Skeleton className="h-4 w-1/2" />

          <Skeleton className="h-4 w-4/5" />

          <Skeleton className="h-4 w-1/3" />
        </div>

        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-3">
            <Skeleton className="rounded-full size-10 bg-white-100" />

            <div className="flex flex-col gap-4 flex-1 bg-white-100 p-4 rounded-lg">
              <Skeleton className="h-6 w-36" />

              <div className="flex flex-col gap-1">
                <Skeleton className="h-4 w-24" />

                <Skeleton className="h-14" />
              </div>

              <div className="ml-auto">
                <Skeleton className="h-10 w-32" />
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <Skeleton className="rounded-full size-10 bg-white-100" />

            <div className="flex flex-col gap-4 flex-1 bg-white-100 p-4 rounded-lg">
              <Skeleton className="h-6 w-48" />
            </div>
          </div>

          <div className="flex items-center gap-3">
            <Skeleton className="rounded-full size-10 bg-white-100" />

            <div className="flex flex-col gap-4 flex-1 bg-white-100 p-4 rounded-lg">
              <Skeleton className="h-6 w-36" />
            </div>
          </div>
        </div>
      </Box>
    </div>
  );
}

export default CreateMaintenanceForwardingDirectiveLoading;
